import styled from 'styled-components'

import blueImage from '../assets/images/hexagon-blue.png'
import yellowImage from '../assets/images/hexagon-yellow.png'
import redImage from '../assets/images/hexagon-red.png'
import purpleImage from '../assets/images/hexagon-purple.png'
import greenImage from '../assets/images/hexagon-green.png'
import cubeImage from '../assets/images/cube.png'

export default function Indicators() {
  return (
    <Container>
      <div className="cell-container name small"></div>
      <div className="cell-container">
        <img className="hexagon" alt="" src={blueImage} />
      </div>
      <div className="cell-container">
        <img className="hexagon" alt="" src={yellowImage} />
      </div>
      <div className="cell-container">
        <img className="hexagon" alt="" src={redImage} />
      </div>
      <div className="cell-container">
        <img className="hexagon" alt="" src={purpleImage} />
      </div>
      <div className="cell-container">
        <img className="hexagon" alt="" src={greenImage} />
      </div>
      <div className="cell-container small">
        <img className="cube" alt="" src={cubeImage} />
      </div>
      <div className="cell-container small last">
        <p>=</p>
      </div>
    </Container>
  )
}

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  width: 12%;

  .cell-container {
    align-items: center;
    border-bottom: solid 1px #bc9b33;
    border-right: solid 2px #bc9b33;
    display: flex;
    flex-direction: column;
    height: 15.5%;
    justify-content: center;
    width: 100%;

    .hexagon {
      height: auto;
      width: 40px;
    }

    .cube {
      height: 24px;
      width: 24px;
    }

    & > p {
      color: #000000;
      font-size: 32px;
    }
  }


  .name {
    border-bottom: solid 3px #bc9b33;
  }

  .small {
    height: 7.5%;
  }

  .last {
    border-bottom: none;
  }
`
